import { useQueryClient } from "@tanstack/react-query"
import { useParams } from "@tanstack/react-router"

import type { AircraftSource } from "#gql/graphql.ts"
import { queryKeys } from "#lib/query-keys.ts"

export function useAircraftSource(): AircraftSource {
  const { aircraftId } = useParams({
    from: "/_authenticated/$slug/fleet/$aircraftId",
  })
  const queryClient = useQueryClient()
  const data = queryClient.getQueryData<{
    aircraftById: { source: AircraftSource }
  }>(queryKeys.aircraft.detail(aircraftId))
  return data?.aircraftById.source ?? "MANUAL"
}
